import { render, staticRenderFns } from "./SelectBrand.vue?vue&type=template&id=8f6ef974&"
import script from "./SelectBrand.vue?vue&type=script&lang=js&"
export * from "./SelectBrand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports